import { logWarning } from 'client/javascript/util/logger';
import { TEAMS } from 'shared/rollbar/global_prefixes';
import {
  EventNameTypes,
  initScrollAnalytics,
  initClickAnalytics,
  initHoverAnalytics
} from 'client/javascript/analytics';

export const TRACKING_DATA = {
  TRACKING_OBJECTS_SELECTOR: 'data-analytics-tracking-data'
};

export const INTERACTION_TRACKING_TYPES = {
  SCROLL: 'scroll',
  CLICK: 'click',
  HOVER: 'hover',
  SCROLL_BELOW: 'scroll-below'
};

export const LOGGING_CONFIG = {
  prefix: '[DynamicAnalytics]',
  team: TEAMS.MARKETING
};

export class InitDynamicAnalytics {
  constructor(customTrackingConfig) {
    this.pageType = document.documentElement.className;
    this.trackingObjectsSelector = customTrackingConfig
      ? customTrackingConfig.trackingObjectsSelector
      : TRACKING_DATA.TRACKING_OBJECTS_SELECTOR;

    this.initAnalytics();
  }

  getTrackingTypeAndData = (trackingEvent) => {
    const { typeOfInteraction, eventType, ...rest } = trackingEvent;

    return {
      eventType: eventType || EventNameTypes.interaction,
      typeOfInteraction,
      trackingData: {
        ...rest,
        ...(this.pageType && { page_type: this.pageType })
      }
    };
  };

  assignTrackingCallByType = ({ typeOfInteraction, trackingData, eventType, targetElement }) => {
    switch (typeOfInteraction) {
      case INTERACTION_TRACKING_TYPES.CLICK:
        initClickAnalytics(trackingData, targetElement, eventType);
        break;
      case INTERACTION_TRACKING_TYPES.SCROLL:
        initScrollAnalytics(trackingData, targetElement, eventType);
        break;
      case INTERACTION_TRACKING_TYPES.HOVER:
        initHoverAnalytics(trackingData, targetElement, eventType);
        break;
      default:
        break;
    }
  };

  prepareTrackingData = (trackingData, nodeDom) => {
    return Object.entries(trackingData).reduce((acc, [key, value]) => {
      if (value === '{{href}}') {
        acc[key] = nodeDom.href;
      } else {
        acc[key] = value;
      }

      return acc;
    }, {});
  };

  initAnalytics() {
    const trackingObjects = document.querySelectorAll(`[${this.trackingObjectsSelector}]`);

    if (!trackingObjects.length) {
      return;
    }

    trackingObjects.forEach((pageElement) => {
      const analyticsTrackingData = pageElement.getAttribute(this.trackingObjectsSelector);

      if (!analyticsTrackingData) {
        return;
      }

      let trackingEvents = [];

      try {
        trackingEvents = JSON.parse(analyticsTrackingData);
      } catch (error) {
        logWarning(`${LOGGING_CONFIG.prefix}[initAnalytics()] failed parse JSON`, {
          team: LOGGING_CONFIG.team
        });
        return;
      }

      trackingEvents.forEach((trackingEvent) => {
        const { typeOfInteraction, eventType, trackingData } = this.getTrackingTypeAndData(trackingEvent);
        const updatedTrackingData = this.prepareTrackingData(trackingData, pageElement);

        if (typeOfInteraction) {
          this.assignTrackingCallByType({
            targetElement: pageElement,
            trackingData: updatedTrackingData,
            typeOfInteraction,
            eventType
          });
        }
      });
    });
  }
}
